import { Injectable } from '@angular/core';
import {VendorInvoiceService} from './vendor-invoice.service';
import {MatDialog} from '@angular/material/dialog';
import {VendorInvoiceDialogComponent} from '../../vendor-invoices/vendor-invoice-dialog/vendor-invoice-dialog.component';
import { IWGSharedService } from './shared.service';

@Injectable({
  providedIn: 'root'
})
export class VendorInvoiceDialogService {

    constructor(private dialog: MatDialog, private vendorinvoice: VendorInvoiceService, private sharedService:IWGSharedService) {
  }
  
  show(ev = null, existingVendorInvoiceId): void {
    if (existingVendorInvoiceId) {
      this.vendorinvoice.getVendorInvoiceById(existingVendorInvoiceId).subscribe(
          res => {
            this.showVendorInvoiceDialog(ev, res.data.Data);
      });
    } else {
      this.showVendorInvoiceDialog(ev, null);
    }
  }

  showVendorInvoiceDialog(ev, vendorInvoice): void {
    this.sharedService.isBlurredBg.next(true);
       const dialogRef = this.dialog.open(VendorInvoiceDialogComponent, {
       panelClass: ['iwg-form-dialogfull'], maxWidth: '100%',
       autoFocus: false,
        data :{
          existingInvoice: vendorInvoice
        }
     });
       dialogRef.afterClosed().subscribe(result => {
        this.sharedService.isBlurredBg.next(false);         
       });
     }

}
